import { useState } from 'react';
import Card from 'react-bootstrap/Card';
import userOS from '../../hooks/useriOSHook';
import logo from '../../images/logo-full-impact-v1-1.png';
import install from '../../images/icon-apple-share-1.png';
import './PromptInstall.scss';

export default function PromptInstall() {
  const [display, setDisplay] = useState<boolean>(true);

  return (
    <div
      id="schedule-prompt-install-container"
      className={`container d-flex justify-content-center${(userOS().prompt && display) ? ' d-block' : ' d-none'}`}
    >
      <Card
        id="schedule-prompt-install-card"
        className="fade-in-bottom mx-3"
        bg="light"
        style={{
          position: 'absolute',
          bottom: 2,
          zIndex: 5,
          boxShadow: '0px 0px 15px -5px #1113'
        }}>

        <Card.Body className="container d-flex justify-content-center align-items-center">
          <div style={{ maxWidth: "400px" }} className="">
            <div style={{ marginTop: "-50px" }} className="text-center">
              <img
                src={logo}
                height="72"
                alt="Add to Home Screen"
              />
            </div>
            <div className="text-center">
              <h4>Install Full Impact Training Schedule</h4>
            </div>
            <hr />
            <p className="text-center my-3">Install our schedule app on your homescreen for a quicker scheduling experience.</p>
            <div className="text-center">
              <p className="fw-lighter fs-5 my-4">
                Tap
                <img
                  src={install}
                  style={{ margin: "auto 4px 8px" }}
                  className="d-inline-block"
                  alt="Add to homescreen"
                  height="20"
                  width="20"
                />
                then &quot;Add to Home Screen&quot;
              </p>
            </div>
            <hr />
            <div className="text-center">
              <button
                className="mt-2 mb-1"
                type="button"
                onClick={() => setDisplay(!display)}
              >
                Close
              </button>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}